import "vue";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const n = (e) => typeof e < "u";
export {
  n as isDef
};
